(function ($) {
  if (typeof window.SHGMoney === "function") {
    oldFormat = SHGMoney.prototype.formatMoney;
    SHGMoney.prototype.formatMoney = function (cents) {
      const formattedMoney = oldFormat.call(this, cents);
      const result = `${formattedMoney.replace(/((\,00)|(\.00))\s*\b/g, '')} ${
        formattedMoney.includes(this.config.currency)
        ? ''
        : this.config.currency
      }`;

      return result;
    };
  }
  function onElementLoad(options) {
    var loaded = false;
    var timer = setInterval(function () {
      if ($(options.selector).length) {
        loaded = true;
      }

      if (loaded) {
        clearInterval(timer);
        options.callback();
      }
    }, 100);
  }

  function updateVariantPrice($product, variant) {
    var priceFormatted = Shopify.formatMoney(
      variant.price,
      theme.settings.moneyFormat
    );
    console.log(
      $product,
      variant,
      priceFormatted,
      $product.find('.shg-product-price')
    );
    $product
      .find('.shg-product-price')
      .html(
        priceFormatted.includes(Shopify.currency.active)
          ? priceFormatted
          : priceFormatted + ' ' + Shopify.currency.active
      );
  }

  function updateAllPrices() {
    _.each(window.__shgProducts, function (product) {
      var $product = $(`span:contains("${product.title}")`).closest(
        '.shg-product'
      );
      //console.log(item, $product);
      var $variantSelect = $product.find('.shg-product-variant-select');
      $variantSelect.attr('data-product-id', product.id);
      $product.attr('data-product-id', product.id);
      var variant = product.variants.filter(function (v) {
        return v.title == $variantSelect.val();
      });

      if (variant.length) {
        variant = variant[0];
        updateVariantPrice($product, variant);
      }
    });
  }

  function initShogun() {
    if (typeof window.__shgProducts !== 'undefined') {
      var products = [];
      _.each(window.__shgProducts, function (product) {
        products.push(product);
      });

      setTimeout(updateAllPrices, 1000);
      $(document).on('click', '.shogun-accordion-heading', function (e) {
        updateAllPrices();
      });

      $(document).on('change', '.shg-product-variant-select', function (e) {
        console.log(e);
        var $variantSelect = $(e.target);
        var productId = $variantSelect.data('product-id');
        var $product = $(`.shg-product[data-product-id="${productId}"]`);
        var product = products.filter(function (p) {
          return p.id == productId;
        })[0];

        var variant = product.variants.filter(function (v) {
          return v.title == $variantSelect.val();
        });

        if (variant.length) {
          variant = variant[0];
          updateVariantPrice($product, variant);
        }

        setTimeout(function () {
          $product
            .find('.shg-product-variant-select')
            .attr('data-product-id', productId);
        }, 500);
      });
    }
  }

  $(document).ready(function () {
    initShogun();
  });
})(jQuery);
